// extracted by css-extract-rspack-plugin
export default {"empty":"gE56WaoNcJPR1dLT","labels":"WsAsVSMyqzMjYY2G"};